<div class="jumbotron jumbotron-fluid memic-banner" style="background-color: rgb(75, 202, 239)">
  <div class="memic-banner__wrapper">
    <div class="memic-banner__body">
      <div class="memic-banner__body__inner">
        <h1 class="display-4" style="color: white !important;">MEMIC Minutes</h1>
        <p class="lead" style="color: white !important;">To reduce your risk of injury, practice these safety tips</p>
      </div>
    </div>
    <img class="memic-banner__image" src="../../../assets/images/MEMICMinutesHeader.jpg">
  </div>
</div>

<div class="memic-page memic-page--boxed">
  <safetydirector-breadcrumb [pageName]="pageName"></safetydirector-breadcrumb>

  <div class="row m-b-2">
    <div class="col-md-8">
      <div ngbDropdown class="d-inline-block">
        <label class="p-l-4 p-r-1 dropdown-label" for="industries">Industry</label>
        <button type="button" class="btn memic-btn--outlined" id="dropdownBasic1" ngbDropdownToggle>{{selectedIndustry}}</button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <button ngbDropdownItem *ngFor="let industry of primaryIndustries" (click)="updateIndustry(industry.name)">{{industry.name}}</button>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div ngbDropdown class="d-inline-block pull-right">
        <label class="p-r-1 dropdown-label" for="industries">Sort</label>
        <button type="button" class="btn memic-btn--outlined" id="ddSort" ngbDropdownToggle>{{sortTitle}}</button>
        <div ngbDropdownMenu aria-labelledby="ddSort">
          <button ngbDropdownItem (click)="updateSortBy('modified', 'Publish Date', 'desc')">Publish Date</button>
          <button ngbDropdownItem (click)="updateSortBy('title', 'Title', 'asc')">Title</button>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-3">
      <div class="memic-panel panel">
        <div class="panel-heading">
          <h3 class="panel-title">Featured Topics</h3>
        </div>

        <div class="memic-list__body p-l-1" *ngIf="featuredTopicsCheckArray && featuredTopicsCheckArray.length > 0">
          <section class="memic-refiner m-r-1 m-t-1" *ngFor="let ftc of featuredTopicsCheckArray; let i=index">
            {{ftc}}<a class="fa fa-times p-l-1 m-r-1" href="javascript:void(null)" (click)="onClearRefiner(ftc, 'featuredTopic')" aria-hidden="true"></a>
          </section>

          <a class="memic-clear-refiner m-r-1 m-t-1" href="javascript:void(null)" (click)="onResetRefiner('featuredTopic')">Clear All</a>
        </div>

        <div class="panel-body memic-list--filter">
          <div *ngFor="let featuredTopic of featuredTopics; let i=index">
            <label>
              <input type="checkbox" [value]="featuredTopic" (change)="onCheckboxChange($event, 'featuredTopic')" />
              {{featuredTopic}}
            </label>
          </div>
        </div>
      </div>

      <div class="memic-panel panel">
        <div class="panel-heading">
          <h3 class="panel-title">Secondary Featured Topics</h3>
        </div>

        <div class="memic-list__body p-l-1" *ngIf="secondaryFeaturedTopicsCheckArray && secondaryFeaturedTopicsCheckArray.length > 0">
          <section class="memic-refiner m-r-1 m-t-1" *ngFor="let stc of secondaryFeaturedTopicsCheckArray; let i=index">
            {{stc}}<a class="fa fa-times p-l-1 m-r-1" href="javascript:void(null)" (click)="onClearRefiner(stc, 'secondaryFeaturedTopic')" aria-hidden="true"></a>
          </section>

          <a class="memic-clear-refiner m-r-1 m-t-1" href="javascript:void(null)" (click)="onResetRefiner('secondaryFeaturedTopic')">Clear All</a>
        </div>

        <div class="panel-body memic-list--filter">
          <div *ngFor="let secondaryFeaturedTopic of secondaryFeaturedTopics; let i=index">
            <label>
              <input type="checkbox" [value]="secondaryFeaturedTopic" (change)="onCheckboxChange($event, 'secondaryFeaturedTopic')" />
              {{secondaryFeaturedTopic}}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-9">
      <div class="memic-panel panel">
        <div class="panel-body">
          <section *ngIf="!resources">
            <em>Loading Resources...</em>
          </section>
          <section *ngIf="resources">
            <!-- Search Box -->
            <div class="memic-input-group memic-input-group--borderless input-group memic-search--page">
              <input [(ngModel)]="searchString" (keyup.enter)="filterResources()" name="searchString" type="text" placeholder="Search">
              <button type="button" (click)="filterResources(true)" class="btn bg-transparent" style="margin-left: -40px; z-index: 100;">
                <i class="fa fa-times"></i>
              </button>
              <span (click)="filterResources()" class="input-group-addon"><i class="fa fa-search" aria-hidden="true"></i></span>
            </div>
            <!--// Search Box -->

            <div class="row">
              <div class="col-md-12">
                <span class="badge badge-primary">{{resources.length}} Resources</span>
              </div>
            </div>

            <ul class="memic-list memic-list--details memic-list--brdless list-group m-a-0" *ngFor="let r of resources">
              <li class="memic-list__body list-group-item p-x-0">
                <div class="memic-list__body-left">
                  <img #fileIcon class="memic-icn memic-icn-png" [src]="'../assets/icons/' + r.blobExtension.replace('.', '') +'.png'">
                </div>
                <div class="memic-list__body-right">
                  <header class="memic-list__header">
                    <h2 class="memic-list__title"><a href="javascript:void(null)" (click)="downloadFile(r, fileIcon)">{{r.title}}</a></h2>
                  </header>
                  <div class="memic-list__content">{{r.resourceDescription}}</div>

                  <!-- Tags -->
                  <div class="memic-list__body" [innerHTML]="getKeyWordsHtml(r, true)">
                  </div>
                  <div class="memic-list__body" [innerHTML]="getKeyWordsHtml(r, false)" *ngIf="r.more">
                  </div>

                  <!-- // Tags -->
                  <!-- Tags Accordion -->
                  <a *ngIf="getKeyWords(r).length > tagsLength" class="memic-tag m-r-1 m-t-1" href="javascript:void(null)" (click)="toggleTags(r)">
                    <i class="fa p-l-1 m-r-1" [ngClass]="{'fa-plus': !r.more, 'fa-minus' : r.more }" aria-hidden="true"> </i>
                    <span *ngIf="!r.more" class="p-r-1">more</span>
                    <span *ngIf="r.more" class="p-r-1">less</span>
                  </a>
                  <!-- // Tags Accordion -->
                  <!-- Related Documents-->
                  <a *ngIf="r.relatedDocument.length > 0" class="memic-tag m-t-1" data-bs-toggle="collapse" href="#related-docs-{{r.id}}" [attr.data-bs-target]="'#related-docs-' +r.id" role="button" aria-expanded="false" aria-controls="collapseRelatedDocumets">
                    <i class="fa fa-paperclip m-r-2" aria-hidden="true"></i>{{r.relatedDocument.length}} Related Documents
                  </a>
                  <div class="memic-list__content accordion-collapse collapse" [attr.aria-labelledby]="'related-docs-' + r.id" id="related-docs-{{r.id}}">
                    <header class="memic-list__header m-b-2" *ngFor="let relatedDoc of r.relatedDocument">
                      <h2 class="memic-list__title"><a href="javascript:void(null)" (click)="downloadFile(relatedDoc, fileIcon)">{{relatedDoc.title}}</a></h2>
                    </header>
                  </div>
                  <!-- // Related Documents-->
                </div>
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
